import config from "../../config";
import Moment from "moment";
import $ from "jquery";
import Sidebar from "../../components/partials/Sidebar";
import Header from "../../components/partials/Header";
import Breadcrumb from "../../components/Breadcrumb";
import { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./style.css";
import Pagination from "../../components/Pagination";
import deleteIcon from "../../images/icons/delete.png";
import viewIcon from "../../images/icons/view.png";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import Swal from "sweetalert2";
import filter from "../../images/icons/filter.png";
import moment from "moment";
import DownloadExcel from "../../components/DownloadExcel";
import { millionComma, getFilteredStockInTypes, isStockTransferOnly, isStockAdjustmentOnly, isStockActionAllowed, isStockEditAllowed, isStockBranchAllowed, isStockCancelAllowed, printStockTransfer } from "../../utils";
import editIcon from "../../images/icons/edit.png";
import printIcon from "../../images/icons/print.png";
import { ConfigContext } from "../../App";
import { FcApproval } from "react-icons/fc";
import { FaInfoCircle } from "react-icons/fa";

function StockAdjustment(props) {
  const [stockInType, setStockInType] = useState([]);
  const [stockAdjusmentType, setStockAdjusmentType] = useState([]);
  const [user, setUser] = useState({});
  const configCtx = useContext(ConfigContext);
  const loginBranch = configCtx?.loginBranch;
  const branchList = configCtx?.branchList;
  const erpIntegration = configCtx?.erpIntegration;
  const [isErpLoading, setIsErpLoading] = useState(false);
  const [showPageLoader, setShowPageLoader] = useState(false);

  const location = useLocation();

  // useEffect(function () {
  //   if (localStorage.getItem("inventory")) {
  //     setUser(JSON.parse(localStorage.getItem("inventory")).userData);
  //   }
  // }, []);

  useEffect(
    function () {
      setStockInType(props.stockInType);
      setStockAdjusmentType(props.stockAdjusmentType);
    },
    [props],
  );

  console.log("props.stockInType", props.stockInType);

  const initialState = {
    stk_adj_type: "",
    stk_adj_date: "",
    from_date: "",
    to_date: "",
    is_active: "",
    branch_id: "",
    sync_status: "",
  };

  // const [formInputs, setFormInputs] = useState(initialState);
  let newFilter = location.state?.appliedFilter || initialState;
  let newFilterVisiblity = location.state?.filterDisplay;
  let backToCurrPage = location.state?.backToCurrent;

  const [formInputs, setFormInputs] = useState(newFilter);
  const [filtersVisible, setFiltersVisible] = useState(
    newFilterVisiblity === true ? true : false,
  );
  const [filterActive, setFilterActive] = useState(
    location.state?.appliedFilter ? true : false,
  );

  // const [filtersVisible, setFiltersVisible] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);

  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  // const [currentPage, setCurrentPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(
    backToCurrPage ? backToCurrPage : 1,
  );
  const [totalPage, setTotalPage] = useState(0);
  const [actionPendingId, setActionPendingId] = useState(null);

  const initialPageSize = location.state?.pageSize || 10;
  const [userCount, setUserCount] = useState(initialPageSize);

  function toggleItemDetail(id) {
    $(`#${id}`).is(":visible")
      ? $(`#${id}`).addClass("d-none")
      : $(`#${id}`).removeClass("d-none");
  }

  function changeStatus(stk_adj_id, is_active) {
    let branch_id = JSON.parse(localStorage.getItem("inventory"))?.userData
      ?.branch_data?.[0]?.branch_id;
    confirmAlert({
      title: "Are you sure?",
      message: `You want to  ${is_active == 3 ? "unfreeze" : "cancel"
        } ${isStockTransferOnly(user) ? "stock transfer" : "stock adjustment"}.`,
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            $.post(
              `${config.apiUrl}/StockAdjustment/cancelStockAdjustment`,
              JSON.stringify({ stk_adj_id, is_active, branch_id }),
            )
              .done(function (res) {
                getList(filtersVisible);
                setError("");
                setSuccess(res.message);
                setTimeout(function () {
                  setSuccess("");
                }, 4000);
              })
              .catch(function (err) {
                setSuccess("");
                setError(err.responseJSON.message);
                setTimeout(function () {
                  setError("");
                }, 4000);
              })
              .always(function () {
                setIsSubmit(false);
                setActionPendingId(null);
              });
            setActionPendingId(stk_adj_id);
          },
        },
        {
          label: "No",
        },
      ],
    });
  }
  function ApprovedBranch(stk_adj_id) {
    let branch_id = JSON.parse(localStorage.getItem("inventory"))?.userData
      ?.branch_data?.[0]?.branch_id;

    confirmAlert({
      title: "Are you sure?",
      message: `You want to approve ${isStockTransferOnly(user) ? "Stock transfer" : "Stock adjustment"}`,
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            $.post(
              `${config.apiUrl}/StockAdjustment/manualAutoApprove`,
              JSON.stringify({ stk_adj_id: stk_adj_id }),
            )
              .done(function (res) {
                getList(filtersVisible);
                setError("");
                console.log("sjgsdshdjsjdks", res?.data);
                setSuccess(res?.data);
                setTimeout(function () {
                  setSuccess("");
                }, 4000);
              })
              .catch(function (err) {
                setSuccess("");
                setError(
                  err?.responseJSON?.data?.message ||
                  err?.responseJSON?.message,
                );
                setTimeout(function () {
                  setError("");
                }, 4000);
              })
              .always(function () {
                setActionPendingId(null);
              });
            setActionPendingId(stk_adj_id);
          },
        },
        {
          label: "No",
          onClick: () => { },
        },
      ],
    });
  }

  async function getList(isFilter = true, pageNo = null, perPage = null) {
    const userObj = JSON.parse(localStorage.getItem("inventory"))?.userData;
    let json = {
      paginate: 1,
      page_no: (pageNo || currentPage) - 1,
      branch_id: userObj?.branch_data?.[0]?.branch_id,
    };
    json.page_size = perPage || userCount;
    if (isFilter) {
      json = {
        ...json,
        ...formInputs,
        branch_id:
          userObj?.branch_data?.[0]?.branch_id || formInputs.branch_id,
      };
    }

    // if (isStockTransferOnly(userObj)) {
    //   json.stk_adj_type = 1;
    // }

    await $.post(
      `${config.apiUrl}/StockAdjustment/listStockAdjustment`,
      JSON.stringify(json),
    )
      .done(function (res) {
        setCurrentPage(pageNo || currentPage);
        setList(res?.data?.list);
        setTotalPage(res.data.count);
        setIsLoading(false);
        setIsSubmit(false);
      })
      .catch(function (err) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: err?.responseJSON?.data?.message,
          confirmButtonText: "OK",
          allowEnterKey: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
          focusConfirm: true,
        });
      });
  }

  // useEffect(
  //   function () {
  //     getList(filtersVisible);
  //   },
  //   [currentPage]
  // );
  useEffect(
    function () {
      if (localStorage.getItem("inventory")) {
        setUser(JSON.parse(localStorage.getItem("inventory")).userData);
      }

      getList(filterActive, null);
    },
    [currentPage],
  );

  function handleInputs(e) {
    setFormInputs({ ...formInputs, [e.target.id]: e.target.value });
  }

  function handleFilterVisibility() {
    if (filtersVisible) {
      setFiltersVisible(false);
      setFormInputs(initialState);
    } else {
      setFiltersVisible(true);
    }
  }

  const changePageSize = async (e) => {
    setUserCount(() => e.target.value);
    if (list.length > 0) {
      currentPage == 1
        ? await getList(filterActive, 1, e.target.value)
        : setCurrentPage(() => 1);
    }
  };

  const [exportIds, setExportIds] = useState([]);
  const [isExport, setIsExport] = useState(false);
  const getExportIds = (e) => {
    if (e.target.value === "All") {
      if (e.target.checked) {
        setExportIds((prevState) => [
          ...prevState,
          ...list.filter((v) => v.is_active === 1).map((v) => v.stk_adj_id),
        ]);
      } else {
        setExportIds(() => []);
      }
    } else {
      const val = e.target.value;
      if (e.target.checked) {
        setExportIds((prevState) => [
          ...prevState,
          val.match(/^\d+$/) ? Number(val) : val,
        ]);
      } else {
        setExportIds((prevState) => prevState.filter((v) => v != val));
      }
    }
  };

  const downloadExportJson = async () => {
    if (exportIds.length == 0) {
      Swal.fire("", "Select atleast one Stock Adjustment");
      return;
    }
    let branch_id =
      JSON.parse(localStorage.getItem("inventory"))?.userData?.branch_data?.[0]
        ?.branch_id || formInputs.branch_id;
    setIsExport(true);
    await $.post(
      `${config.apiUrl}/StockAdjustment/exportStockAdjustment`,
      JSON.stringify({
        stk_adj_ids: exportIds,
        branch_id: branch_id,
      }),
    )
      .done(function (res) {
        const jsonData = new Blob([JSON.stringify(res, null, 3)], {
          type: "text/json",
        });
        const jsonURL = window.URL.createObjectURL(jsonData);
        const link = document.createElement("a");
        document.body.appendChild(link);
        link.href = jsonURL;
        link.setAttribute("download", "Stock-Adjustment.json");
        link.click();
        document.body.removeChild(link);
        setIsExport(false);
        getList(filterActive);
      })
      .catch(function (err) {
        setIsExport(false);
        Swal.fire(
          "Error",
          err?.responseJSON?.data?.message || err?.responseJSON?.message,
        );
      });
  };

  const sendERP = async (type = "ERP") => {
    if (exportIds.length == 0) {
      Swal.fire("", "Select atleast one Stock Adjustment");
      return;
    }

    const selectedItems = list.filter((x) => exportIds.includes(x.stk_adj_id));
    const alreadySynced = selectedItems.filter((x) => x.sync_status == 1);

    if (alreadySynced.length > 0) {
      const nos = alreadySynced.map((x) => x.stk_adj_no).join(", ");
      Swal.fire({
        icon: "warning",
        title: "Already synced",
        text: `Stock Adjustment no ${nos} are already synced successfully. Please untick them first and then Send to ERP.`,
        confirmButtonText: "OK",
      });
      return;
    }

    setIsErpLoading(true);
    await $.post(
      `${config.apiUrl}/StockAdjustment/updateErpStatus`,
      JSON.stringify({
        stk_adj_ids: exportIds,
        is_erp: 1,
        type: type,
      }),
    )
      .done(function (res) {
        setIsErpLoading(false);
        Swal.fire({
          icon: "success",
          title: "Success",
          text:
            res?.data?.message ||
            (type === "NON-ERP"
              ? "Stock Adjustment successfully marked for Non ERP."
              : "Stock Adjustment successfully sent to ERP."),
        });
        getList(filterActive);
      })
      .catch(function (err) {
        setIsErpLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            err?.responseJSON?.data?.message ||
            err?.responseJSON?.message ||
            "Something went wrong while sending to ERP",
        });
      });
  };

  return (
    <>
      <div className="d-flex min-vh-100" style={{ background: "#DAE5FF" }}>
        <Sidebar />
        <div
          id="pageLoader"
          style={{
            display: showPageLoader !== false ? "block" : "none",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            zIndex: 99999,
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              color: "#fff",
              textAlign: "center",
            }}
          >
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p
              className="mt-2"
              style={{ fontSize: "16px", fontWeight: "bold" }}
            >
              {showPageLoader}
            </p>
          </div>
        </div>
        <div className="content m-1 p-2">
          <Header />

          <main className="bg-white rounded-2" id="stock">
            <div className="container-fluid p-2">
              <div className="row">
                <div className="col">
                  <Breadcrumb path={[isStockTransferOnly(user) ? "Stock Transfer" : "Stock Adjustment"]} />
                </div>
                <div className="col text-end">
                  <Tippy content="Filter">
                    <img
                      onClick={() => handleFilterVisibility()}
                      src={filter}
                      className="img-fluid me-3"
                      alt=""
                      role="button"
                      style={{ width: "2rem" }}
                    />
                  </Tippy>
                  <span className=" me-3">
                    <label className="me-1">Per Page</label>
                    <select
                      value={userCount}
                      onChange={(e) => changePageSize(e)}
                      className="custom-select"
                      style={{
                        height: "32px",
                      }}
                    >
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>

                  {isStockActionAllowed(user) && (
                    <Link
                      to="/stock-adjustment/add"
                      className="btn btn-primary px-4 py-2"
                      style={{
                        height: "33px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        float: "right",
                      }}
                    >
                      {isStockTransferOnly(user) ? "New Stock Transfer" : "New Stock adjustment"}
                    </Link>
                  )}
                </div>
              </div>

              {filtersVisible && (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    setIsSubmit(true);
                    setFilterActive(true);
                    currentPage > 1 ? setCurrentPage(1) : getList(true, 1);
                  }}
                  id="purchaseAdd"
                  className="my-3"
                  autoComplete="off"
                >
                  <div className="row g-3 mb-2">
                    <div className="col-md">
                      <label htmlFor="stk_adj_no">Stock No</label>
                      <input
                        type="text"
                        className="form-control"
                        id="stk_adj_no"
                        value={formInputs.stk_adj_no}
                        onChange={(e) =>
                          setFormInputs({
                            ...formInputs,
                            stk_adj_no: e.target.value,
                          })
                        }
                      />
                    </div>

                    <div className="col-md">
                      <label htmlFor="stock_in_type">Stock In Type</label>
                      <select
                        className="form-select"
                        id="stk_adj_type"
                        name="stk_adj_type"
                        value={formInputs.stk_adj_type}
                        onChange={(e) =>
                          setFormInputs({
                            ...formInputs,
                            stk_adj_type: e.target.value,
                          })
                        }
                      >
                        <option value="">All</option>
                        {getFilteredStockInTypes(stockInType, user).map((v, i) => (
                          <option key={i} value={v.value}>
                            {v.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* <div className="col-md">
                      <label htmlFor="item_id">Item</label>
                      <select
                        className="form-select"
                        id="item_id"
                        name="item_id"
                        value={formInputs.item_id}
                        onChange={(e) =>
                          setFormInputs({
                            ...formInputs,
                            item_id: e.target.value,
                          })
                        }
                      >
                        <option value="">All</option>
                        {stockAdjusmentType.map((v, i) => (
                          <option key={i} value={v.value}>
                            {v.label}
                          </option>
                        ))}
                      </select>
                    </div> */}

                    {user.role_id != 3 && user.role_id != 4 && (
                      <div className="col-md">
                        <label htmlFor="branch_id">Branch</label>
                        <select
                          className="form-select"
                          id="branch_id"
                          name="branch_id"
                          value={formInputs.branch_id}
                          onChange={(e) =>
                            setFormInputs({
                              ...formInputs,
                              branch_id: e.target.value,
                            })
                          }
                        >
                          <option value={""}>select...</option>
                          {props.branchList.map((v, i) => (
                            <option key={i} value={v.value}>
                              {v.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                    <div className="col-md">
                      <label htmlFor="from_date">From Date</label>
                      <input
                        type="date"
                        className="form-control"
                        id="from_date"
                        value={formInputs.from_date}
                        onChange={handleInputs}
                        max={moment().format("YYYY-MM-DD")}
                      />
                    </div>
                    <div className="col-md">
                      <label htmlFor="to_date">To Date</label>
                      <input
                        type="date"
                        className="form-control"
                        id="to_date"
                        value={formInputs.to_date}
                        onChange={handleInputs}
                        max={moment().format("YYYY-MM-DD")}
                      />
                    </div>
                    <div className="col-md">
                      <label htmlFor="status">Status</label>
                      <select
                        className="form-select"
                        id="is_active"
                        name="is_active"
                        value={formInputs.is_active}
                        onChange={(e) =>
                          setFormInputs({
                            ...formInputs,
                            is_active: e.target.value,
                          })
                        }
                      >
                        {[
                          { id: "", name: "All" },
                          { id: 7, name: "Partial Done" },
                          { id: 1, name: "Approved" },
                          { id: 2, name: "Pending Source" },
                          { id: 3, name: "Rejected Source" },
                          { id: 4, name: "Pending Destination" },
                          { id: 5, name: "Rejected Destination" },
                        ].map((v, i) => (
                          <option
                            key={i}
                            value={v.id}
                          // className={v.id === 0 ? "bg-lightgrey" : ""}
                          >
                            {v.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    {erpIntegration == 1 ? (
                      <div className="col-md">
                        <label htmlFor="sync_status">Sync Status</label>
                        <select
                          className="form-select"
                          id="sync_status"
                          name="sync_status"
                          value={formInputs.sync_status}
                          onChange={(e) =>
                            setFormInputs({
                              ...formInputs,
                              sync_status: e.target.value,
                            })
                          }
                        >
                          {[
                            { id: "", name: "All" },
                            { id: 0, name: "Pending" },
                            { id: 1, name: "Success" },
                            { id: 2, name: "Failed" },
                          ].map((v, i) => (
                            <option
                              key={i}
                              value={v.id}
                              className={v.id === 0 ? "bg-lightgrey" : ""}
                            >
                              {v.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : null}
                  </div>
                  <div className="col-md mt-auto">
                    <div
                      className="d-flex gap-2"
                      style={{ display: "flex", alignItems: "end" }}
                    >
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isSubmit}
                        style={{
                          height: "35px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {isSubmit && (
                          <span className="spinner-border spinner-border-sm me-2"></span>
                        )}
                        Search
                      </button>
                      <button
                        className="btn btn-primary rounded-3 px-3 ms-2"
                        type="button"
                        onClick={(e) => {
                          setFormInputs(initialState);
                          currentPage > 1
                            ? setCurrentPage(1)
                            : getList(false, 1);
                        }}
                        style={{
                          background: "#4263eb",
                          fontSize: "14px",
                          height: "35px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        Clear Filters
                      </button>
                      {/* <DownloadExcel
                        link={`${config.apiUrl}/StockAdjustment/listStockAdjustment`}
                        data={formInputs}
                        filename="StockAdjustment"
                      /> */}
                      <button
                        type="button"
                        className="btn btn-primary py-0 ms-2"
                        style={{
                          background: "#4263eb",
                          borderRadius: "8px",
                          fontWeight: "600",
                          fontSize: "14px",
                          height: "35px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          color: "#ffffff",
                        }}
                        onClick={downloadExportJson}
                      >
                        {isExport && (
                          <span className="spinner-border spinner-border-sm me-2"></span>
                        )}
                        Export
                      </button>
                      {erpIntegration == 1 ? (
                        <div className="btn-group ms-2">
                          <button
                            type="button"
                            className="btn btn-primary"
                            style={{
                              background: "#4263eb",
                              borderColor: "#4263eb",
                              borderTopLeftRadius: "8px",
                              borderBottomLeftRadius: "8px",
                              fontWeight: "600",
                              fontSize: "14px",
                              height: "35px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              color: "#ffffff",
                              whiteSpace: "nowrap",
                            }}
                            onClick={() => sendERP("ERP")}
                            disabled={isErpLoading}
                          >
                            {isErpLoading && (
                              <span className="spinner-border spinner-border-sm me-2"></span>
                            )}
                            Mark For ERP
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary dropdown-toggle dropdown-toggle-split"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            disabled={isErpLoading}
                            style={{
                              background: "#3b5bdb",
                              borderColor: "#3b5bdb",
                              borderTopRightRadius: "8px",
                              borderBottomRightRadius: "8px",
                              height: "35px",
                              color: "#ffffff",
                              paddingLeft: "10px",
                              paddingRight: "10px",
                            }}
                          >
                            <span className="visually-hidden">Toggle Dropdown</span>
                          </button>
                          <ul
                            className="dropdown-menu dropdown-menu-end shadow"
                            style={{ minWidth: "160px", zIndex: 1050 }}
                          >
                            <li>
                              <button
                                type="button"
                                className="dropdown-item py-2 fw-semibold"
                                onClick={() => sendERP("ERP")}
                              >
                                Mark For ERP
                              </button>
                            </li>
                            <li>
                              <button
                                type="button"
                                className="dropdown-item py-2 fw-semibold"
                                onClick={() => sendERP("NON-ERP")}
                              >
                                Mark For Non ERP
                              </button>
                            </li>
                          </ul>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </form>
              )}

              {(error || success) && (
                <div className="row mt-3">
                  <div className="col">
                    <div
                      className={`alert alert-${error ? "danger" : "success"
                        } py-1 small`}
                      role="alert"
                    >
                      {error || success || ""}
                    </div>
                  </div>
                </div>
              )}

              <div className="row mb-4">
                <div className="col table-responsive-lg">
                  <table
                    className={`table ${error || success ? "my-1" : "mt-4"
                      } rounded`}
                  >
                    <thead>
                      <tr>
                        <th>
                          <input
                            type="checkbox"
                            id="All"
                            value="All"
                            onChange={(e) => getExportIds(e)}
                          />
                        </th>
                        <th>Stock No</th>
                        <th>Stock In Type</th>
                        {user?.role_id !== 3 && user?.role_id !== 4 && (
                          <th>Branch Name</th>
                        )}
                        <th>Narration</th>
                        <th style={{ width: "100px" }}>Date</th>
                        <th className="text-end">Export Count</th>
                        <th>Status</th>
                        {erpIntegration == 1 ? <th>Sync Status</th> : null}
                        <th style={{ minWidth: "125px", whiteSpace: "nowrap" }} className="text-center">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(isLoading || list?.length === 0) && (
                        <tr>
                          <td colSpan={erpIntegration == 1 ? (user?.role_id !== 3 && user?.role_id !== 4 ? "10" : "9") : (user?.role_id !== 3 && user?.role_id !== 4 ? "9" : "8")} className="text-center">
                            {isLoading ? "Loading..." : "No Records"}
                          </td>
                        </tr>
                      )}
                      {list &&
                        list?.map((v, i) => (
                          <>
                            <tr
                              key={`pl_` + i}
                              className={v?.is_active ? "" : "bg-lightgrey"}
                              style={
                                v?.export_count > 0
                                  ? {
                                    backgroundColor: `rgba(var(--theme-btn-color-rgb, 13, 202, 240), ${Math.min(
                                      v?.export_count * 0.15,
                                      1,
                                    )})`,
                                  }
                                  : {}
                              }
                            >
                              <td>
                                {v.is_active === 1 && (
                                  <input
                                    type="checkbox"
                                    value={v?.stk_adj_id}
                                    checked={exportIds.includes(v?.stk_adj_id)}
                                    onChange={(e) => getExportIds(e)}
                                  />
                                )}
                              </td>
                              <td>
                                <span
                                  className="link-primary user-select-none"
                                  role="button"
                                  onClick={() => toggleItemDetail(`pli_${i}`)}
                                >
                                  {v.stk_adj_no}
                                </span>
                              </td>
                              <td>
                                {stockInType.find(
                                  (s) => s.value == v.stk_adj_type,
                                )?.label || "N/A"}
                              </td>
                              {user?.role_id !== 3 && user?.role_id !== 4 && (
                                <td>
                                  {props?.branchList?.find(
                                    (b) => b.value === v.branch_id,
                                  )?.label || "N/A"}
                                </td>
                              )}
                              <td>{v.narration}</td>
                              <td>
                                {Moment(v.stk_adj_date, "YYYY-MM-DD").format(
                                  "DD-MM-YY",
                                )}
                              </td>
                              <td className="text-end">
                                {v?.export_count || "0"}
                              </td>
                              <td>
                                {(() => {
                                  const statusMap = {
                                    0: {
                                      label: "Reject",
                                      color: "text-bg-danger",
                                    },
                                    1: {
                                      label: "Approved",
                                      color: "text-bg-success",
                                    },
                                    2: {
                                      label: "Pending Source",
                                      color: "text-bg-warning",
                                    },
                                    3: {
                                      label: "Rejected Source",
                                      color: "text-bg-danger",
                                    },
                                    4: {
                                      label: "Pending Destination",
                                      color: "text-bg-warning",
                                    },
                                    5: {
                                      label: "Rejected Destination",
                                      color: "text-bg-danger",
                                    },
                                    6: {
                                      label: "Approval Pending",
                                      color: "text-bg-warning",
                                    },
                                    7: {
                                      label: "Partial Done",
                                      color: "text-bg-info",
                                    },
                                  };

                                  const status = statusMap[v.is_active];
                                  return status ? (
                                    <span className={`badge ${status.color}`}>
                                      {status.label}
                                    </span>
                                  ) : null;
                                })()}
                              </td>
                              {erpIntegration == 1 && (
                                <td>
                                  {v.is_erp == 1
                                    ? (() => {
                                      const status = v?.sync_status;

                                      if (status === 0) {
                                        return (
                                          <span
                                            className="badge bg-warning"
                                            style={{ fontSize: "11px" }}
                                          >
                                            Pending
                                          </span>
                                        );
                                      }

                                      if (status === 1) {
                                        return (
                                          <span
                                            className="badge bg-success"
                                            style={{ fontSize: "11px" }}
                                          >
                                            Success
                                          </span>
                                        );
                                      }

                                      if (status === 2) {
                                        return (
                                          <>
                                            <span
                                              className="badge bg-danger"
                                              style={{ fontSize: "11px" }}
                                            >
                                              Failed
                                            </span>

                                            <Tippy
                                              content={
                                                v?.sync_err || "Sync Error"
                                              }
                                            >
                                              <span
                                                style={{ cursor: "pointer" }}
                                              >
                                                <FaInfoCircle
                                                  style={{
                                                    fontSize: "15px",
                                                    marginLeft: "5px",
                                                  }}
                                                />
                                              </span>
                                            </Tippy>
                                          </>
                                        );
                                      }

                                      return (
                                        <span className="text-muted">-</span>
                                      );
                                    })()
                                    : "NA"}
                                </td>
                              )}

                              {/* <td className="">
                                {v.is_active ? (
                                  <span className="badge text-bg-success">
                                    Active
                                  </span>
                                ) : (
                                  <span className="badge text-bg-danger">
                                    In-Active
                                  </span>
                                )}
                              </td> */}

                              <td className="edit text-nowrap" style={{ whiteSpace: "nowrap" }}>
                                <div className="d-inline-flex align-items-center gap-1">
                                  <Tippy content="View">
                                    <Link
                                      to={
                                        `/stock-adjustment/view/` + v.stk_adj_id
                                      }
                                      state={{
                                        stock: v,
                                        viewOnly: true,
                                        currentPageNo: currentPage,
                                        currentFilter: formInputs,
                                        showFilter: filtersVisible,
                                      }}
                                      className={`link-info m-1`}
                                    >
                                      <img
                                        src={viewIcon}
                                        className="img-fluid"
                                        alt=""
                                      />
                                    </Link>
                                  </Tippy>
                                  <Tippy content="Print">
                                    <button
                                      type="button"
                                      className="btn border-0 p-0 m-1"
                                      style={{ fontSize: "12px", lineHeight: "1" }}
                                      onClick={() => {
                                        printStockTransfer(
                                          v?.stk_adj_id,
                                          setShowPageLoader
                                        );
                                      }}
                                    >
                                      <img
                                        src={printIcon}
                                        className="img-fluid"
                                        alt="Print"
                                        style={{ width: "18px" }}
                                      />
                                    </button>
                                  </Tippy>
                                  {isStockEditAllowed(user, v.is_active, v?.created_by) &&
                                    isStockBranchAllowed(user, v.from_branch) && (
                                      <Tippy content="Edit">
                                        <Link
                                          to={
                                            `/stock-adjustment/edit/` +
                                            v.stk_adj_id
                                          }
                                          state={{
                                            stock: v,
                                            viewOnly: true,
                                            currentPageNo: currentPage,
                                            currentFilter: formInputs,
                                            showFilter: filtersVisible,
                                          }}
                                          className="link-info m-1"
                                        >
                                          <img
                                            src={editIcon}
                                            className="img-fluid"
                                            alt=""
                                          />
                                        </Link>
                                      </Tippy>
                                    )}

                                  {/* {user.role_id == 3 && (
                                    <>
                                      {(v.is_active == 5 ||
                                        v.is_active == 3) &&
                                        v.stk_adj_type != 1 && (
                                    <Tippy content="Cancel">
                                      <a
                                        href="#cancel"
                                        onClick={(e) =>
                                          changeStatus(v.stk_adj_id, 0)
                                        }
                                              className={`link-info`}
                                      >
                                              {actionPendingId ===
                                                v.stk_adj_id ? (
                                          <span
                                            className="spinner-border spinner-border-sm me-2"
                                            role="status"
                                            aria-hidden="true"
                                          ></span>
                                        ) : (
                                          <img
                                            src={deleteIcon}
                                            className="img-fluid me-2"
                                            alt=""
                                          />
                                        )}
                                      </a>
                                    </Tippy>
                                  )}
                                    </>
                                  )} */}
                                  {(() => {
                                    const isAdmin = (user?.comp_id === 2 || user?.comp_id === 24 ) && user?.role_id === 2;
                                    const getBranchAutoApprove = (branchId) => {
                                      const br = branchList?.find((b) => Number(b.branch_id) === Number(branchId));
                                      return br?.auto_approve;
                                    };

                                    const showApproveButton = isAdmin
                                      ? false
                                      : (
                                        loginBranch?.auto_approve &&
                                        ((loginBranch?.branch_id == v.branch_id && (v.is_active == 2 || v.is_active == 6)) ||
                                          (loginBranch?.branch_id == v.to_branch && v.is_active == 4))
                                      );

                                    return showApproveButton && (
                                      <Tippy content="Approve">
                                        <a
                                          href="#cancel"
                                          onClick={(e) =>
                                            ApprovedBranch(v.stk_adj_id)
                                          }
                                          className="link-info d-inline-flex align-items-center m-1"
                                        >
                                          {actionPendingId === v.stk_adj_id ? (
                                            <span
                                              className="spinner-border spinner-border-sm"
                                              role="status"
                                              aria-hidden="true"
                                            ></span>
                                          ) : (
                                            <FcApproval size={20} />
                                          )}
                                        </a>
                                      </Tippy>
                                    );
                                  })()}
                                </div>
                              </td>
                            </tr>
                            <tr
                              key={`pli_` + i}
                              id={`pli_` + i}
                              className="d-none"
                            >
                              <td colSpan="8">
                                <div className="table-responsive">
                                  <table className="table table-sm table-bordered ms-auto w-50 py-0 mb-0">
                                    <thead>
                                      <tr style={{ textAlign: "center" }}>
                                        <th>#</th>
                                        <th>Item Name</th>
                                        <th>Qty</th>
                                        <th>Rate</th>
                                        <th>Total</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {v.item_dtl &&
                                        v.item_dtl.map((v, i) => {
                                          return (
                                            <tr key={`plil_` + i}>
                                              <td>{i + 1}</td>
                                              <td>
                                                {props?.item?.find(
                                                  (s) =>
                                                    Number(s?.value) ===
                                                    Number(v?.item_id),
                                                )?.label || "N/A"}
                                              </td>
                                              <td className="text-end">
                                                {millionComma(v.qty)}
                                              </td>
                                              <td className="text-end">
                                                {millionComma(v.rate)}
                                              </td>
                                              <td className="text-end">
                                                {millionComma(v.amount)}
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      {/*<tr>
                                                                    <td
                                                                        colSpan="4"
                                                                        className="text-end pe-2 fw-bold">
                                                                        Gross Total
                                                                    </td>
                                                                    <td className="fw-bold text-end">
                                                                        {parseFloat(v.total_gross_amt).toFixed(
                                                                            4
                                                                        )}
                                                                    </td>
                                                                </tr>*/}
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                            </tr>
                          </>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <Pagination
                    nPages={Math.ceil(totalPage / userCount)}
                    // nPages={Math.ceil(list.length / 10)}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}

export default StockAdjustment;
